import { render, staticRenderFns } from "./BranchTeam.vue?vue&type=template&id=46160a0e&scoped=true"
import script from "./BranchTeam.vue?vue&type=script&lang=js"
export * from "./BranchTeam.vue?vue&type=script&lang=js"
import style0 from "./BranchTeam.vue?vue&type=style&index=0&id=46160a0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46160a0e",
  null
  
)

export default component.exports